"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCollectionHistory = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
/**
 * Retrieves Collection objects from the history_FormData table through the Collection query endpoint.
 * Relies on a feature of the query endpoint that falls back to querying the history table if no results are found.
 * The 'originalId' field is only present on objects in history_FormData, so filtering on 'originalId' will return historical results.
 */
var IkeObjectCollectionHistory = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectCollectionHistory, _super);
    function IkeObjectCollectionHistory() {
        var _this = _super.call(this) || this;
        _this.className = 'CollectionHistory';
        _this.actionName = 'collectionHistory';
        _this.cacheKeys['uuid'] = true;
        _this.cacheKeys['revision'] = true;
        return _this;
    }
    IkeObjectCollectionHistory.prototype.updateCache = function (key, result, rest) {
        _super.prototype.updateCache.call(this, key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
    };
    return IkeObjectCollectionHistory;
}(base_1.IkeRestObject));
exports.IkeObjectCollectionHistory = IkeObjectCollectionHistory;
//# sourceMappingURL=collection.history.object.js.map